// eslint-disable-next-line import/prefer-default-export
export const ModalDialogStyle = {
    root: {
        '& .MuiDialog-paperWidthSm': {
            maxWidth: '90%',
        },
    },
};
